import { useReducer } from 'react';
import { createContainer } from 'react-tracked';

const initialState = {
  showInvestOptionModal: false,
  showAccountPendingVerificationModal: false,
  showInvestModal: false,
  isWithdrawModalOpen: false,
};

const reducer = (
  state,
  action,
) => {
  switch (action.type) {
    case 'openInvestOptionModal':
      return {
        ...state,
        showInvestOptionModal: true,
      };
    case 'closeInvestOptionModal':
      return {
        ...state,
        showInvestOptionModal: false,
      };
    case 'openInvestModal':
      return {
        ...state,
        showInvestModal: true,
        investmentNote: action.investmentNote,
      };
    case 'closeInvestModal':
      return {
        ...state,
        showInvestModal: false,
      };
    case 'openWithdrawModal': {
      return {
        ...state,
        isWithdrawModalOpen: true,
        investmentNote: action.investmentNote,
      };
    }
    case 'closeWithdrawModal': {
      return {
        ...state,
        isWithdrawModalOpen: false,
      };
    }
    default:
      return state;
  }
};

const useValue = () => useReducer(reducer, initialState);

export const {
  Provider: FundProvider,
  useTrackedState: useFundState,
  useUpdate: useFundDispatch,
} = createContainer(useValue);
